import { useApiFetch } from '@/services/api-client.ts';

export default function useApalumaAnalytics() {
   const sendUserActivity = async () => {
      await useApiFetch('analytics/user-activity', {
         method: 'POST',
         query: {
            source: 'web',
         },
      });
   };

   return {
      sendUserActivity,
   };
}
